import { apiUrls } from 'sdk/api-urls'
import {
  PaginationFilterModel,
  PaginatedApiResponseModel,
  UserWithSubAccounts,
  ChangeUserStatusPayload,
  ChangeUserRolePayload,
  UserSubscriptionInfoViewModel,
  UserIpLogViewMode,
} from 'sdk/models'
import { BaseApi } from '../base.api'

export class AdminUserApi extends BaseApi {
  public getUserWithSubAccounts(filter: PaginationFilterModel) {
    return this.GET_Request<PaginatedApiResponseModel<UserWithSubAccounts>>(
      apiUrls.admin.getUsersWithSubAccounts(filter)
    )
  }
  public getUserSubscriptionInfo(userId: string) {
    return this.GET_Request<UserSubscriptionInfoViewModel>(apiUrls.admin.getUserSubscriptionInfo(userId))
  }
  public getUserIpRecentLogs(userid: string) {
    return this.GET_Request<UserIpLogViewMode[]>(apiUrls.admin.getIpRecentIpLogs(userid))
  }
  public changeUserStatus(data: ChangeUserStatusPayload) {
    return this.POST_Request<boolean>(apiUrls.admin.changeUserStatus(), data)
  }
  public changeUserRole(data: ChangeUserRolePayload) {
    return this.POST_Request<boolean>(apiUrls.admin.changeUserRole(), data)
  }
}
